import React from 'react';
import { S } from './style';
/**
 *
 * @description RWD Loading component for CareClientCareOrderBabyRequest app
 */
export default function Loading() {
    return (<S.Layout>
      <S.Loader>
        <div>Loading</div>
      </S.Loader>
    </S.Layout>);
}
